"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stepState = void 0;
var stepState = {
  ACTIVE: 'active',
  DISABLED: 'disabled',
  PASSED: 'passed',
  HIDDEN: 'hidden'
};
exports.stepState = stepState;